import React from 'react';
import { PDFViewer, PDFDownloadLink, Document } from '@react-pdf/renderer';
import { Flex, Box, Button } from '../../design-system';
import { EXCEL_EXPORTERS } from './excel';
import { downloadExcel } from './excel/utils';

interface ReportProps {
  data: any;
  report: {
    ReportContent: React.ComponentType<any>;
    title: string;
    value?: string;
    [key: string]: any;
  };
  startDate?: string;
  endDate?: string;
  [key: string]: any;
}

const Report = ({
  data,
  report: { ReportContent, title, ...reportData },
  startDate,
  endDate,
  ...meta
}: ReportProps) => {
  // Build a fresh Document element per consumer — reusing one element
  // descriptor across two concurrent react-pdf trees (download link + viewer)
  // is not safe.
  const makeDocument = () => (
    <Document>
      <ReportContent
        data={data}
        meta={{ title, ...reportData, startDate, endDate, ...meta }}
      />
    </Document>
  );

  const baseFileName = `${title || 'Report'}_${startDate}_${endDate}`.replace(
    /\s+/g,
    '_',
  );

  const handleExcelDownload = () => {
    const exporter = EXCEL_EXPORTERS[reportData.value];
    if (!exporter) return;
    const sheets = exporter(data);
    downloadExcel(sheets, `${baseFileName}.xlsx`);
  };

  return (
    <Flex flexDirection="column" height="100%">
      <Flex mb={3}>
        <Box mr={2}>
          <PDFDownloadLink
            document={makeDocument()}
            fileName={`${baseFileName}.pdf`}
          >
            {({ loading }) => (
              <Button variant="green" disabled={loading}>
                {loading ? 'Preparing PDF...' : 'Download PDF'}
              </Button>
            )}
          </PDFDownloadLink>
        </Box>
        <Box>
          <Button variant="green" onClick={handleExcelDownload}>
            Download Excel
          </Button>
        </Box>
      </Flex>
      <Box flex={1}>
        <PDFViewer width="100%" height="100%">
          {makeDocument()}
        </PDFViewer>
      </Box>
    </Flex>
  );
};

export default Report;
